const textLengthToFontSizeRatios = [0, .9, .6, .45, .35, .28, .23, .195, .17, .155, .14, .1];

export const getDrawingNumberFontSizeToCounterLengthRatio = (counterLength: number): number => {
  return textLengthToFontSizeRatios[counterLength] ?? 0;
};
